export default __webpack_public_path__ + "static/cope_thumbnail-e7e04311a93a5ff3b5763e335551890c.png";